import styled from "styled-components"

interface TableHeadProps {
  display?: string
}
export const TableHead = styled.thead<TableHeadProps>`
  ${(props) => (props.display ? `${props.display};` : "")}
  box-sizing: border-box;
`
